import styled from 'styled-components/macro';

const IconsContainer = styled.div`
  margin-top: 3px;
  margin-right: 14px;
  line-height: 0.5;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export default IconsContainer;
